var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainMenuView',{staticClass:"main-menu"},[_c('MainMenu',{attrs:{"is-user-data-ready":_vm.isUserDataReady,"routes":_vm.routes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }